import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { getAuthToken } from './helpers/auth-storage.helper';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const token = getAuthToken();

  if (token) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
